import React from "react";
import { Edit2, Trash2, MapPin, Users, Info } from "lucide-react";

const IndexRow = ({ venue, onEdit, onDelete }) => {
  // Helper untuk styling status badge
  const getStatusStyle = (status) => {
    switch (status?.toLowerCase()) {
      case "active":
        return "bg-emerald-100 text-emerald-600 dark:bg-emerald-500/10 dark:text-emerald-400";
      case "maintenance":
        return "bg-amber-100 text-amber-600 dark:bg-amber-500/10 dark:text-amber-400";
      default:
        return "bg-slate-100 text-slate-600 dark:bg-slate-500/10 dark:text-slate-400";
    }
  };

  return (
    <>
      {/* Kolom 1: Venue Name */}
      <td className="px-6 py-4 rounded-l-xl">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-blue-50 dark:bg-blue-500/10 flex items-center justify-center border border-blue-100 dark:border-blue-500/20">
            <Info size={18} className="text-blue-600" />
          </div>
          <div>
            <p className="text-xs font-black text-stone-800 dark:text-white uppercase tracking-tight">
              {venue.name}
            </p>
            <p className="text-[10px] text-stone-400 font-medium">ID: VEN-{venue.id.toString().padStart(3, '0')}</p>
          </div>
        </div>
      </td>

      {/* Kolom 2: Location */}
      <td className="px-6 py-4">
        <div className="flex items-center gap-2 text-stone-600 dark:text-stone-300">
          <MapPin size={14} className="text-blue-500" />
          <span className="text-[11px] font-bold uppercase tracking-tight leading-none">
            {venue.location}
          </span>
        </div>
      </td>

      {/* Kolom 3: Capacity (Center) */}
      <td className="px-6 py-4 text-center">
        <div className="inline-flex items-center gap-1.5 px-3 py-1 bg-stone-50 dark:bg-white/5 rounded-full border border-stone-100 dark:border-white/10">
          <Users size={12} className="text-stone-400" />
          <span className="text-[10px] font-black text-stone-700 dark:text-stone-200">
            {venue.capacity.toLocaleString()} PAX
          </span>
        </div>
      </td>

      {/* Kolom 4: Status (Center) */}
      <td className="px-6 py-4 text-center">
        <span className={`px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-widest ${getStatusStyle(venue.status)}`}>
          {venue.status}
        </span>
      </td>

      {/* Kolom 5: Actions (Center) */}
      <td className="px-6 py-4 rounded-r-xl text-center">
        <div className="flex items-center justify-center gap-2">
          <button 
            onClick={() => onEdit(venue)}
            className="p-2.5 bg-white dark:bg-slate-800 hover:bg-blue-50 dark:hover:bg-blue-500/20 text-stone-400 hover:text-blue-600 rounded-xl transition-all shadow-sm border border-stone-100 dark:border-white/10 active:scale-90"
            title="Edit Venue"
          >
            <Edit2 size={14} />
          </button>
          <button 
            onClick={() => onDelete && onDelete(venue.id)}
            className="p-2.5 bg-white dark:bg-slate-800 hover:bg-red-50 dark:hover:bg-red-500/20 text-stone-400 hover:text-red-600 rounded-xl transition-all shadow-sm border border-stone-100 dark:border-white/10 active:scale-90"
            title="Delete Venue"
          >
            <Trash2 size={14} />
          </button>
        </div>
      </td>
    </>
  );
};

export default IndexRow;